import gql from 'graphql-tag';

export const CourseS12nInfoV2Fragment = gql`
  fragment CourseS12nInfoV2Fragment on XdpV1_org_coursera_xdp_cdp_CDPS12n {
    id
    name
    slug
    productVariant
    courses {
      id
    }
    courseCount
  }
`;

export const ClipsCourseDetailsQuery = gql`
  query ClipsCourseDetailsQuery($courseSlug: String!) {
    XdpV1Resource {
      slug(productType: "COURSE", slug: $courseSlug) {
        elements {
          id
          xdpMetadata {
            __typename
            ... on XdpV1_cdpMetadataMember {
              cdpMetadata {
                id
                name
                slug
                description
                primaryLanguages
                photoUrl
                skills
                totalEnrollmentCount
                averageContentSatisfactionScore
                primaryS12n {
                  ...CourseS12nInfoV2Fragment
                }
                ratings {
                  averageFiveStarRating
                  ratingCount
                }
                courseTypeMetadata {
                  __typename
                }
                partners {
                  id
                  shortName
                  name
                  squareLogo
                }
                domains {
                  domainId
                  domainName
                  subdomainId
                  subdomainName
                }
              }
            }
          }
        }
      }
    }
    OnDemandCoursesV1Resource {
      slug(slug: $courseSlug) {
        elements {
          id
          overridePartnerLogos
        }
      }
    }
  }
  ${CourseS12nInfoV2Fragment}
`;

export const SFCVLPCourseMaterialsQuery = gql`
  query SFCVLPCourseMaterialsQuery($courseId: String!, $anonymousAccess: Boolean!) {
    OnDemandLearnerMaterialsV1Resource {
      courses(courseIds: [$courseId], anonymousAccess: $anonymousAccess) {
        elements {
          id
          learnerMaterialItems(limit: 1000) {
            lectures: elements {
              id: itemId
              name
              lessonId
              isPassedOrCompleted
              timeCommitment: totalWorkDuration
              contentSummary {
                __typename
              }
              slug
            }
          }
          learnerMaterialLessons(limit: 250) {
            elements {
              id: lessonId
              moduleId
              itemIds
              name
            }
          }
          learnerMaterialModules(limit: 250) {
            elements {
              id: moduleId
              name
              description
              lessonIds
            }
          }
        }
      }
    }
  }
`;

export const SFCVLPProgramMembershipsByUserQuery = gql`
  query SFCVLPProgramMembershipsByUserQuery($userId: String!) {
    ProgramMembershipsV2Resource {
      byUser(userId: $userId) {
        elements {
          id
          enterpriseProgram(eventualConsistency: true) {
            id
            thirdPartyOrganizationId
            metadata {
              slug
            }
          }
        }
      }
    }
  }
`;
